var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "homepage" },
    [
      _c(
        "div",
        { staticClass: "btn" },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.save } },
            [_vm._v("保存")]
          ),
        ],
        1
      ),
      _c("div", { staticClass: "auto-table-flex" }, [
        _c("div", { staticClass: "homepagecnt" }, [
          _c(
            "div",
            { staticClass: "box1" },
            [
              _c("div", { staticClass: "box1-title" }, [_vm._v("首页背景图")]),
              _c("div", { staticStyle: { display: "flex" } }, [
                _c("div", [
                  _c("div", { staticStyle: { "margin-bottom": "5px" } }, [
                    _vm._v(" 请上传尺寸为：750x296的图片； "),
                  ]),
                  _c(
                    "div",
                    { staticStyle: { "margin-bottom": "10px" } },
                    [
                      _c(
                        "el-upload",
                        {
                          class: { hide: _vm.homepage1.length == 1 },
                          attrs: {
                            "element-loading-text": "正在上传...",
                            action: `${_vm.BASE.PRO1}/common/upload`,
                            headers: { token: _vm.token },
                            "on-success": (file) => {
                              return _vm.successFile(file, "homepage1")
                            },
                            "on-error": (file) => {
                              return _vm.errorFile(file, "homepage1")
                            },
                            "before-upload": (file) => {
                              return _vm.handleBeforeUpload(file, 750, 296)
                            },
                            "file-list": _vm.homepage1,
                            "list-type": "picture-card",
                            "before-remove": (file, fileList) => {
                              return _vm.deleteFile(file, fileList, "homepage1")
                            },
                            limit: 1,
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "el-icon-plus",
                            attrs: { slot: "trigger" },
                            slot: "trigger",
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
                _c("div", [
                  _c("div", { staticStyle: { "margin-bottom": "5px" } }, [
                    _vm._v(" 请上传尺寸为：750x342的图片； "),
                  ]),
                  _c(
                    "div",
                    { staticStyle: { "margin-bottom": "10px" } },
                    [
                      _c(
                        "el-upload",
                        {
                          class: { hide: _vm.homepage2.length == 1 },
                          attrs: {
                            "element-loading-text": "正在上传...",
                            action: `${_vm.BASE.PRO1}/common/upload`,
                            headers: { token: _vm.token },
                            "on-success": (file) => {
                              return _vm.successFile(file, "homepage2")
                            },
                            "on-error": (file) => {
                              return _vm.errorFile(file, "homepage2")
                            },
                            "before-upload": (file) => {
                              return _vm.handleBeforeUpload(file, 750, 342)
                            },
                            "file-list": _vm.homepage2,
                            "list-type": "picture-card",
                            "before-remove": (file, fileList) => {
                              return _vm.deleteFile(file, fileList, "homepage2")
                            },
                            limit: 1,
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "el-icon-plus",
                            attrs: { slot: "trigger" },
                            slot: "trigger",
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
              _c("div", { staticClass: "box1-title" }, [_vm._v("首页logo图")]),
              _c("div", { staticStyle: { "margin-bottom": "5px" } }, [
                _vm._v("请上传尺寸为：372x50的图片；"),
              ]),
              _c(
                "div",
                { staticStyle: { "margin-bottom": "10px" } },
                [
                  _c(
                    "el-upload",
                    {
                      class: { hide: _vm.homepage3.length == 1 },
                      attrs: {
                        "element-loading-text": "正在上传...",
                        action: `${_vm.BASE.PRO1}/common/upload`,
                        headers: { token: _vm.token },
                        "before-upload": (file) => {
                          return _vm.handleBeforeUpload(file, 372, 50)
                        },
                        "file-list": _vm.homepage3,
                        "list-type": "picture-card",
                        "on-success": (file) => {
                          return _vm.successFile(file, "homepage3")
                        },
                        "on-error": (file) => {
                          return _vm.errorFile(file, "homepage3")
                        },
                        "before-remove": (file, fileList) => {
                          return _vm.deleteFile(file, fileList, "homepage3")
                        },
                        limit: 1,
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "el-icon-plus",
                        attrs: { slot: "trigger" },
                        slot: "trigger",
                      }),
                    ]
                  ),
                ],
                1
              ),
              _c("div", { staticClass: "box1-title" }, [
                _vm._v("我的页面背景图"),
              ]),
              _c("div", { staticStyle: { display: "flex" } }, [
                _c("div", [
                  _c("div", { staticStyle: { "margin-bottom": "5px" } }, [
                    _vm._v(" 请上传尺寸为：750x194的图片； "),
                  ]),
                  _c(
                    "div",
                    { staticStyle: { "margin-bottom": "10px" } },
                    [
                      _c(
                        "el-upload",
                        {
                          class: { hide: _vm.mypage1.length == 1 },
                          attrs: {
                            "element-loading-text": "正在上传...",
                            action: `${_vm.BASE.PRO1}/common/upload`,
                            headers: { token: _vm.token },
                            "on-success": (file) => {
                              return _vm.successFile(file, "mypage1")
                            },
                            "on-error": (file) => {
                              return _vm.errorFile(file, "mypage1")
                            },
                            "before-upload": (file) => {
                              return _vm.handleBeforeUpload(file, 750, 194)
                            },
                            "file-list": _vm.mypage1,
                            "list-type": "picture-card",
                            "before-remove": (file, fileList) => {
                              return _vm.deleteFile(file, fileList, "mypage1")
                            },
                            limit: 1,
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "el-icon-plus",
                            attrs: { slot: "trigger" },
                            slot: "trigger",
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
                _c("div", [
                  _c("div", { staticStyle: { "margin-bottom": "5px" } }, [
                    _vm._v(" 请上传尺寸为：750x358的图片； "),
                  ]),
                  _c(
                    "div",
                    { staticStyle: { "margin-bottom": "10px" } },
                    [
                      _c(
                        "el-upload",
                        {
                          class: { hide: _vm.mypage2.length == 1 },
                          attrs: {
                            "element-loading-text": "正在上传...",
                            action: `${_vm.BASE.PRO1}/common/upload`,
                            headers: { token: _vm.token },
                            "on-success": (file) => {
                              return _vm.successFile(file, "mypage2")
                            },
                            "on-error": (file) => {
                              return _vm.errorFile(file, "mypage2")
                            },
                            "before-upload": (file) => {
                              return _vm.handleBeforeUpload(file, 750, 358)
                            },
                            "file-list": _vm.mypage2,
                            "list-type": "picture-card",
                            "before-remove": (file, fileList) => {
                              return _vm.deleteFile(file, fileList, "mypage2")
                            },
                            limit: 1,
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "el-icon-plus",
                            attrs: { slot: "trigger" },
                            slot: "trigger",
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
              _c("div", { staticClass: "box1-title" }, [
                _vm._v("通用页面背景图"),
              ]),
              _c("div"),
              _c("div", { staticStyle: { "margin-bottom": "5px" } }, [
                _vm._v("请上传尺寸为：750x128的图片；"),
              ]),
              _c(
                "div",
                { staticStyle: { "margin-bottom": "10px" } },
                [
                  _c(
                    "el-upload",
                    {
                      class: { hide: _vm.categorypage.length == 1 },
                      attrs: {
                        "element-loading-text": "正在上传...",
                        action: `${_vm.BASE.PRO1}/common/upload`,
                        headers: { token: _vm.token },
                        "before-upload": (file) => {
                          return _vm.handleBeforeUpload(file, 750, 128)
                        },
                        "on-success": (file) => {
                          return _vm.successFile(file, "categorypage")
                        },
                        "on-error": (file) => {
                          return _vm.errorFile(file, "categorypage")
                        },
                        "file-list": _vm.categorypage,
                        "list-type": "picture-card",
                        "before-remove": (file, fileList) => {
                          return _vm.deleteFile(file, fileList, "categorypage")
                        },
                        limit: 1,
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "el-icon-plus",
                        attrs: { slot: "trigger" },
                        slot: "trigger",
                      }),
                    ]
                  ),
                ],
                1
              ),
              _c("div", { staticClass: "box1-title" }, [_vm._v("活动专区")]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.hdclick } },
                [_vm._v("选择活动模版")]
              ),
              _vm.request_data.activity_config_type == 1
                ? _c("div", { staticClass: "hd-box" }, [
                    _c("div", { staticStyle: { "margin-bottom": "10px" } }, [
                      _vm._v(
                        " 活动1尺寸：412x260 活动2尺寸：262x120 活动3尺寸：262x120 "
                      ),
                    ]),
                    _c("div", { staticStyle: { display: "flex" } }, [
                      _c(
                        "div",
                        {
                          staticClass: "hd-box1",
                          on: {
                            click: function ($event) {
                              return _vm.hdpop(1, 412, 260)
                            },
                          },
                        },
                        [_vm._v("+")]
                      ),
                      _c("div", { staticStyle: { flex: "1" } }, [
                        _c(
                          "div",
                          {
                            staticClass: "hd-box2",
                            staticStyle: { "margin-bottom": "20px" },
                            on: {
                              click: function ($event) {
                                return _vm.hdpop(2, 262, 120)
                              },
                            },
                          },
                          [_vm._v(" + ")]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "hd-box2",
                            on: {
                              click: function ($event) {
                                return _vm.hdpop(3, 262, 120)
                              },
                            },
                          },
                          [_vm._v("+")]
                        ),
                      ]),
                    ]),
                  ])
                : _vm.request_data.activity_config_type == 2
                ? _c("div", { staticClass: "hd-box" }, [
                    _c("div", { staticStyle: { "margin-bottom": "10px" } }, [
                      _vm._v(" 活动1尺寸：412x160 活动2尺寸：262x160 "),
                    ]),
                    _c("div", { staticStyle: { display: "flex" } }, [
                      _c(
                        "div",
                        {
                          staticClass: "hd-box1",
                          on: {
                            click: function ($event) {
                              return _vm.hdpop(1, 412, 160)
                            },
                          },
                        },
                        [_vm._v("+")]
                      ),
                      _c("div", { staticStyle: { flex: "1" } }, [
                        _c(
                          "div",
                          {
                            staticClass: "hd-box2",
                            on: {
                              click: function ($event) {
                                return _vm.hdpop(2, 262, 160)
                              },
                            },
                          },
                          [_vm._v("+")]
                        ),
                      ]),
                    ]),
                  ])
                : _vm.request_data.activity_config_type == 3
                ? _c("div", { staticClass: "hd-box" }, [
                    _c("div", { staticStyle: { "margin-bottom": "10px" } }, [
                      _vm._v("请上传尺寸为：694x160的图片"),
                    ]),
                    _c("div", { staticStyle: { display: "flex" } }, [
                      _c(
                        "div",
                        {
                          staticClass: "hd-box1",
                          on: {
                            click: function ($event) {
                              return _vm.hdpop(1, 694, 160)
                            },
                          },
                        },
                        [_vm._v("+")]
                      ),
                    ]),
                  ])
                : _vm._e(),
            ],
            1
          ),
          _c("div", { staticClass: "box2" }, [
            _c(
              "div",
              {
                staticClass: "bj1",
                style: {
                  backgroundImage: `url(${_vm.request_data.homepage_background.url1})`,
                },
              },
              [
                _vm.request_data.homepage_background.url3
                  ? _c("img", {
                      staticStyle: { width: "186px", height: "25px" },
                      attrs: {
                        src: _vm.request_data.homepage_background.url3,
                        alt: "",
                      },
                    })
                  : _vm._e(),
                _vm._m(0),
              ]
            ),
            _c("div", { staticClass: "cnts" }, [
              _c(
                "div",
                {
                  staticClass: "bj2",
                  style: {
                    backgroundImage: `url(${_vm.request_data.homepage_background.url2})`,
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "搜索",
                      "prefix-icon": "el-icon-search",
                    },
                  }),
                  _c(
                    "el-carousel",
                    {
                      staticClass: "carouselhig",
                      staticStyle: { "margin-top": "20px" },
                      attrs: { interval: 6000 },
                    },
                    _vm._l(_vm.tablebannerData, function (item, index) {
                      return _c("el-carousel-item", { key: index }, [
                        _c("img", {
                          staticClass: "imgbanner",
                          attrs: { src: item.url, alt: "" },
                        }),
                      ])
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "jgq" },
                [
                  _c(
                    "el-carousel",
                    { attrs: { height: "150px", interval: 6000 } },
                    _vm._l(_vm.tableDataSwiper, function (item, index) {
                      return _c("el-carousel-item", { key: index }, [
                        _c(
                          "div",
                          { staticClass: "swiper-jgq" },
                          _vm._l(item.data, function (item1) {
                            return _c(
                              "div",
                              {
                                key: item1.unique_code,
                                staticClass: "swiper-jgq-item",
                              },
                              [
                                _c("img", {
                                  staticStyle: {
                                    width: "40px",
                                    height: "40px",
                                    "border-radius": "50%",
                                    "object-fit": "cover",
                                  },
                                  attrs: { src: item1.radius_pic, alt: "" },
                                }),
                                _c("div", [_vm._v(_vm._s(item1.name))]),
                              ]
                            )
                          }),
                          0
                        ),
                      ])
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm.request_data.activity_config_type == 3
                ? _c("div", { staticClass: "img1" }, [
                    _vm.hd1
                      ? _c("img", { attrs: { src: _vm.hd1, alt: "" } })
                      : _vm._e(),
                  ])
                : _vm._e(),
              _vm.request_data.activity_config_type == 2
                ? _c("div", { staticClass: "img2" }, [
                    _vm.hd1
                      ? _c("img", {
                          staticClass: "imgbox111",
                          attrs: { src: _vm.hd1, alt: "" },
                        })
                      : _vm._e(),
                    _vm.hd2
                      ? _c("img", {
                          staticClass: "imgbox222",
                          attrs: { src: _vm.hd2, alt: "" },
                        })
                      : _vm._e(),
                  ])
                : _vm._e(),
              _vm.request_data.activity_config_type == 1
                ? _c("div", { staticClass: "img3" }, [
                    _c("div", { staticClass: "img3boxleft" }, [
                      _vm.hd1
                        ? _c("img", { attrs: { src: _vm.hd1, alt: "" } })
                        : _vm._e(),
                    ]),
                    _c("div", { staticClass: "img3boxright" }, [
                      _vm.hd2
                        ? _c("img", {
                            staticClass: "yi",
                            attrs: { src: _vm.hd2, alt: "" },
                          })
                        : _vm._e(),
                      _vm.hd3
                        ? _c("img", {
                            staticClass: "er",
                            attrs: { src: _vm.hd3, alt: "" },
                          })
                        : _vm._e(),
                    ]),
                  ])
                : _vm._e(),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "box1", staticStyle: { "padding-bottom": "20px" } },
            [
              _c("div", { staticClass: "box1-title" }, [_vm._v("金刚区")]),
              _c(
                "div",
                { staticClass: "auto-table-flex" },
                [
                  _c(
                    "el-table",
                    {
                      ref: "draggableTable",
                      attrs: {
                        data: _vm.tableData,
                        height: "100%",
                        "row-key": "unique_code",
                        border: true,
                        "header-cell-style": {
                          color: "#333333",
                          background: "#EFF6FF",
                        },
                      },
                      on: { "row-dragged": _vm.handleRowDragged },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          type: "index",
                          width: "100px",
                          align: "center",
                          label: "序号",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "name",
                          align: "center",
                          label: "品类名称",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "radius_pic",
                          align: "center",
                          label: "图标",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("el-image", {
                                  staticStyle: {
                                    width: "20px",
                                    height: "20px",
                                  },
                                  attrs: {
                                    src: scope.row.radius_pic,
                                    "preview-src-list": [scope.row.radius_pic],
                                  },
                                }),
                                _c(
                                  "div",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.upimg(
                                              scope.row,
                                              scope.$index
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("变更图标")]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "as_no",
                          align: "center",
                          label: "操作",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [_c("i", { staticClass: "el-icon-rank" })]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
        ]),
      ]),
      _vm.centerDialogVisible
        ? _c(
            "el-dialog",
            {
              staticClass: "dialog",
              attrs: {
                title: "选择活动模版",
                visible: _vm.centerDialogVisible,
                width: "800px",
                center: "",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.centerDialogVisible = $event
                },
              },
            },
            [
              _c(
                "el-carousel",
                {
                  attrs: {
                    autoplay: false,
                    "initial-index": _vm.initialindex,
                    trigger: "click",
                  },
                  on: { change: _vm.changecl },
                },
                _vm._l(3, function (item, index) {
                  return _c("el-carousel-item", { key: index }, [
                    item == 1
                      ? _c("div", { staticClass: "hd-box" }, [
                          _c(
                            "div",
                            { staticStyle: { "margin-bottom": "10px" } },
                            [
                              _vm._v(
                                " 活动1尺寸：412x260 活动2尺寸：262x120 活动3尺寸：262x120 "
                              ),
                            ]
                          ),
                          _c("div", { staticStyle: { display: "flex" } }, [
                            _c("div", { staticClass: "hd-box1" }, [
                              _vm._v("+"),
                            ]),
                            _c("div", { staticStyle: { flex: "1" } }, [
                              _c(
                                "div",
                                {
                                  staticClass: "hd-box2",
                                  staticStyle: {
                                    "margin-bottom": "20px",
                                    height: "60px",
                                  },
                                },
                                [_vm._v(" + ")]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "hd-box2",
                                  staticStyle: { height: "60px" },
                                },
                                [_vm._v("+")]
                              ),
                            ]),
                          ]),
                        ])
                      : item == 2
                      ? _c("div", { staticClass: "hd-box" }, [
                          _c(
                            "div",
                            { staticStyle: { "margin-bottom": "10px" } },
                            [_vm._v(" 活动1尺寸：412x160 活动2尺寸：262x160 ")]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: { display: "flex", height: "140px" },
                            },
                            [
                              _c("div", { staticClass: "hd-box1" }, [
                                _vm._v("+"),
                              ]),
                              _c("div", { staticStyle: { flex: "1" } }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "hd-box2",
                                    staticStyle: { height: "100%" },
                                  },
                                  [_vm._v("+")]
                                ),
                              ]),
                            ]
                          ),
                        ])
                      : item == 3
                      ? _c("div", { staticClass: "hd-box" }, [
                          _c(
                            "div",
                            { staticStyle: { "margin-bottom": "10px" } },
                            [_vm._v("请上传尺寸为：694x160的图片")]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: { display: "flex", height: "140px" },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "hd-box1",
                                  staticStyle: { flex: "1" },
                                },
                                [_vm._v("+")]
                              ),
                            ]
                          ),
                        ])
                      : _vm._e(),
                  ])
                }),
                1
              ),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.centerDialogVisible = false
                        },
                      },
                    },
                    [_vm._v("取 消")]
                  ),
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.hdmb } },
                    [_vm._v("保存当前模版")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c("iconPopUpfrom", {
        ref: "iconPopUpfromref",
        on: { imgchange: _vm.imgchange },
      }),
      _c("hdPopUpfrom", {
        ref: "hdPopUpfromref",
        on: { hdchange: _vm.hdchange },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("i", { staticClass: "el-icon-location-outline" }),
      _vm._v(" XXX 仓 "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }